var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 33.5,
    height: 33.5,
    rx: 4.75,
    fill: "#FCFCFC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 33.5,
    height: 33.5,
    rx: 4.75,
    stroke: "#DAD8D8",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 24V27H7V24C7 23.45 7.45 23 8 23H26C26.55 23 27 23.45 27 24Z",
    fill: "#DC1F5C",
    stroke: "#DC1F5C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M13 16H9V23H13V16Z",
    fill: "#DC1F5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17 16H13V23H17V16Z",
    fill: "#DC1F5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M21 16H17V23H21V16Z",
    fill: "#DC1F5C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M25 16H21V23H25V16Z",
    fill: "#DC1F5C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28 27.75H6C5.59 27.75 5.25 27.41 5.25 27C5.25 26.59 5.59 26.25 6 26.25H28C28.41 26.25 28.75 26.59 28.75 27C28.75 27.41 28.41 27.75 28 27.75Z",
    fill: "#DC1F5C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.37 10.75L17.37 7.15003C17.17 7.07003 16.83 7.07003 16.63 7.15003L7.63 10.75C7.28 10.89 7 11.3 7 11.68V15C7 15.55 7.45 16 8 16H26C26.55 16 27 15.55 27 15V11.68C27 11.3 26.72 10.89 26.37 10.75ZM17 13.5C16.17 13.5 15.5 12.83 15.5 12C15.5 11.17 16.17 10.5 17 10.5C17.83 10.5 18.5 11.17 18.5 12C18.5 12.83 17.83 13.5 17 13.5Z",
    fill: "#DC1F5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultBank);
export default __webpack_public_path__ + "static/media/default_bank.7c5ba14a8c93c974fd7f67dcea294190.svg";
export { ForwardRef as ReactComponent };